<template>
  <div>
    <b-card header-tag="header" class="mb-4" v-if="hasApiAccess()">
      <template slot="header">
        <h3>API Key</h3>
      </template>
      <p>By generating a new API key your existing one will be revoked and overwritten.</p>
      <button class="btn btn-primary" @click="generateKey()">Generate Key</button>
      <div class="mt-3" v-if="apiToken">
        <p>Here is your new API Key, please store it in a safe place. This won't be displayed after you leave this page.</p>
        <div class="api-key mt-3">{{ apiToken }}</div>
      </div>
    </b-card>
    <b-card header-tag="header">
      <template slot="header">
        <h3>Reset Password</h3>
      </template>
      <p v-if="!passwordHasBeenReset">You will be sent a link to reset your password.</p>
      <button class="btn btn-primary" @click="generatePasswordReset()">Reset Password</button>
      <div class="mt-3" v-if="passwordHasBeenReset">
        <p
          class="mb-0"
        >A link to reset your password has been sent to your email address. If you do not receive an email within 5 minutes, please check your SPAM folder.</p>
      </div>
    </b-card>
  </div>
</template>

<script>
import router from "@/router";
import PortalSidebar from "@/components/PortalSidebar.vue";
import PortalPageHeader from "@/components/PortalPageHeader.vue";
import { EventBus } from "@/services/event-bus.js";
import { updateApiKey, resetPassword } from "@/services/api";
import { getCurrentUser, hasApiAccess } from "@/services/usersession";

export default {
  name: "Settings",
  components: {
    PortalSidebar,
    PortalPageHeader
  },
  data() {
    return {
      apiToken: null,
      passwordHasBeenReset: false,
      user: null
    };
  },
  mounted() {
    // load current user from session
    this.user = getCurrentUser(this.$session);
  },
  methods: {
    async generatePasswordReset() {
      EventBus.$emit("showLoader");
      try {
        await resetPassword(this.user.email);
        EventBus.$emit("triggerAlert", {
          type: "success",
          message: "Reset password email has been sent"
        });
        this.passwordHasBeenReset = true;
      } catch (e) {
        EventBus.$emit("triggerAlert", {
          type: "danger",
          message: "Reset password email could not be sent"
        });
      }
      EventBus.$emit("hideLoader");
    },
    async generateKey() {
      if (
        confirm(
          "Are you sure you want to generate a new API key? Your existing key will be revoked and overwritten."
        )
      ) {
        EventBus.$emit("showLoader");
        try {
          const userId = this.user.id;
          const result = await updateApiKey(userId);
          this.apiToken = result.apiKey;
          EventBus.$emit("triggerAlert", {
            type: "success",
            message: "API Key was generated successfully"
          });
        } catch (result) {
          switch (result.status) {
            case 422: {
              this.validationErrors = result.body.errors;
              EventBus.$emit("triggerAlert", {
                type: "danger",
                message: "API key could not be generated"
              });
              break;
            }
            default: {
              EventBus.$emit("triggerAlert", {
                type: "danger",
                message: "An unknown error occurred"
              });
              break;
            }
          }
        }
        EventBus.$emit("hideLoader");
      }
    },
    hasApiAccess() {
      return hasApiAccess(this.$session);
    }
  }
};
</script>
<style lang="scss">
@import "../assets/styles/main.scss";
.api-key {
  position: relative;
  padding: 15px 20px;
  font-size: 1.2rem;
  background: #fff;
  border: 1px solid $ui-gray-lighter;
  border-radius: $border-radius;
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.05);
}
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue